import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import VueMoment from 'vue-moment';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';

import App from './App';
import router from './router';

// Webcomponents that can be used outside of Vue components (like in Ionic dialogs)
import '@/components/webcomponents/SvgImage';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import store from './store';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.config.productionTip = false;
Vue.use(VueMoment);

// Add a universal router-link directive so you can use it as an attribute
Vue.directive('router-link', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', () => {
      vnode.context.$router.push(binding.value);
    });
    el.classList.add('router-link');
  },
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');

if (window.location.hostname != 'localhost') {
  // Don't enable Sentry when testing locally
  console.log(
    'Enable Sentry',
    process.env.VUE_APP_BRANCH,
    process.env.VUE_APP_RELEASE,
  );
  const branch = process.env.VUE_APP_BRANCH;
  const release = process.env.VUE_APP_RELEASE;
  const environment = branch;
  Sentry.init({
    dsn:
      'https://2992bd6314bb45eeb93892e5a295b67c@o371444.ingest.sentry.io/5438886',
    environment,
    release,
    integrations: [
      new Integrations.BrowserTracing(),
      new VueIntegration({
        Vue,
        logErrors: true,
        tracing: true,
      }),
    ],
    tracesSampleRate: 0.1,
  });
}
